import React from 'react';
import './detailHeaderBoxEmployee.css'

const DetailHeaderBoxEmployee = ({ position, experience }) => {
  
  return (
    <div className='detail-header-box-employee__detail-header-container'>
        <div className="detail-header-box-employee__label-container">
            <label>POSICION</label>
            <p>Ayudante cocina</p>
        </div>
        <div className="detail-header-box-employee__label-container">
          <label>EXPERIENCIA</label>
          <p>3 años</p>
        </div>
        <div className="detail-header-box-employee__label-container">
            <label>DISPONIBILIDAD</label>
            <p>Inmediata</p>
        </div>
        <div className="detail-header-box-employee__label-container">
          <label>JORNADA</label>
          <p>Full-time</p>
        </div>
    </div>
  );
};

export default DetailHeaderBoxEmployee;
